// Grupperom-side: samme chat-shell som DashboardLayout (gradient + IconRail), med
// gruppe-rom-innholdet. GroupRoomsView rendrer kun innholds-panene (ingen rail).
import { IconRail } from "./components/IconRail";
import { GroupRoomsView } from "./components/GroupRoomsView";

export function GroupRoomsPage() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-[radial-gradient(120%_120%_at_50%_0%,#134e4a_0%,#0a2a2e_42%,#020617_100%)] text-white">
      <IconRail />
      <GroupRoomsView />
    </div>
  );
}
